import CardHeader from "components/CardHeader";
import { Account } from "models/Account";
import { Project } from "models/Project";
import React, { useEffect, useMemo, useState } from "react";
import { Link } from "react-router-dom";
import { Card, CardBody } from "reactstrap";
import * as api from "services/Api";
import { useOfficeTranslation } from "i18n/OfficeTranslation";
import ResponsibleHoursChart from "./ResponsibleHoursChart";

const AccountProjectsCard: React.FC<{ accountId: string }> = ({ accountId }) => {
    const { intlLocale, t } = useOfficeTranslation();
    const [projects, setProjects] = useState<Project[]>([]);
    const [accounts, setAccounts] = useState<Account[]>([]);
    useEffect(() => {
        api.getProjects(accountId).then(values => setProjects(values.sort(
            (a, b) => new Date(a.start_date).getTime() - new Date(b.start_date).getTime()
        )));
        api.getAccounts().then(setAccounts).catch(() => setAccounts([]));
    }, [accountId]);
    const workerProjects = useMemo(
        () => projects.filter(project => project.workers.some(worker => worker.account_id === accountId)),
        [accountId, projects],
    );
    const accountById = useMemo(
        () => new Map(accounts.map(account => [account.id, account])),
        [accounts],
    );
    return <Card id="projects"><CardBody>
        <CardHeader title={t("common.projects")} icon="mdi-briefcase-outline" count={projects.length} />
        {workerProjects.length > 0 && <div className="border-bottom py-3">
            <ResponsibleHoursChart
                accountById={accountById}
                projects={workerProjects}
                workerId={accountId}
            />
        </div>}
        {projects.map(project => <div className="d-flex justify-content-between align-items-center border-bottom py-3" key={project.id}>
            <div><Link to={`/projects/${project.id}`}><strong>{project.name}</strong></Link>
                <small className="d-block text-muted">
                    {new Date(project.start_date).toLocaleDateString(intlLocale)} – {new Date(project.end_date).toLocaleDateString(intlLocale)}
                </small>
            </div>
            <Link className="btn btn-sm btn-light" to={`/projects/${project.id}`}><i className="mdi mdi-chevron-right" /></Link>
        </div>)}
        {projects.length === 0 && <p className="text-muted mt-3 mb-0">{t("accounts.accountProjectsCard.noProjectsLinkedToThisAccount")}</p>}
    </CardBody></Card>;
};

export default AccountProjectsCard;
